export default __webpack_public_path__ + "static/media/me1.b19dbda9.gif";